
<template>

	<b-row>

		<b-col v-for="desc in plots" :key="desc.id" class="mb-4" style="min-width: 50%;">

			<pair_plot
				:key="desc.id" :ref="'plot_' + desc.id"
				:id="id" :plot_id="desc.id" :data="data" :initial_x="desc.initial_x" :initial_y="desc.initial_y" :attrs="attrs" :last_plot="last_plot"
				v-on:add_plot="add_plot" v-on:delete_plot="() => delete_plot(desc.id)"
				v-on:export_models="export_models" v-on:bring_back="() => $emit('bring_back')"
				v-on:x_changed="id => set_x(desc.id, id)" v-on:y_changed="id => set_y(desc.id, id)"/>

		</b-col>

	</b-row>

</template>

<script>

import { uuid } from "vue-uuid"
import api from "../../../../../../api"
import attrs from "../../../../../../api/attrs"
import o from "./../objects"
import pair_plot from "./pair_plot"

export default
{
	props :
	{
		id : String,
		data : Object,
	},

	components :
	{
		pair_plot,
	},

	watch :
	{
		data :
		{
			immediate : true,
			
			handler(data)
			{
				if(data)
				{
					var attr_ids = []

					data.attrs.forEach(attr => attr_ids.push(attr.id))

					attrs.get(this).then(
						desc =>
						{
							this.attrs_all = desc.attrs

							this.new_attrs(attr_ids)
							this.refresh()
						})
				}
			}
		},
	},

	computed :
	{
		last_plot()
		{
			return this.plots.length == 1
		},
	},

	data()
	{
		return {

			service : "cadastral_analogues",

			attrs : [],
			attrs_all : [],
			plots : [],

		}
	},

	mounted()
	{
		o.objects().bus.$on("attrs_changed", ev => this.new_attrs(ev.ids))
	},

	methods :
	{
		refresh()
		{
			if(this.data == null || this.attrs_all.length == 0)
				return

			Object.entries(this.data.pair_plots).forEach(
				desc =>
				{
					const plot_id = desc[0]

					if(this.plots.findIndex(plot => plot.id == plot_id) < 0)
					{
						const pair = desc[1]

						this.add_plot(plot_id, pair.x.id, pair.y.id)
					}
				})

			if(Object.keys(this.data.pair_plots).length == 0 && this.attrs_all.length)
			{
				const uprs_attr = this.attrs_all.find(attr => attr.key == "attrs.uprs")

				this.add_plot(null, uprs_attr.id, uprs_attr.id)
			}
		},

		new_attrs(attr_ids)
		{
			var attrs = []
			var uprs_attr = null

			this.attrs_all.forEach(
				attr =>
				{
					if(attr.key == "attrs.uprs")
						uprs_attr = attr
					if(attr_ids.find(id => attr.id == id))
						attrs.push(attr)
				})

			this.attrs = [ uprs_attr, ...attrs ]

			for(var ind = this.plots.length - 1; ind >= 0; ind --)
			{
				const plot = this.plots[ind]

				if(( attr_ids.findIndex(id => plot.initial_x == id) < 0 && plot.initial_x != uprs_attr.id ) || ( attr_ids.findIndex(id => plot.initial_y == id) < 0 && plot.initial_y != uprs_attr.id ))
					this.delete_plot(plot.id)
			}
		},

		add_plot(plot_id = null, x_attr_id = null, y_attr_id = null)
		{
			if(plot_id == null)
				plot_id = uuid.v1()

			this.plots.push({ id : plot_id, initial_x : x_attr_id, initial_y : y_attr_id })

			if(this.data.pair_plots[plot_id] == null)
			{
				const x_attr = this.attrs.find(attr => attr.id == x_attr_id)
				const y_attr = this.attrs.find(attr => attr.id == y_attr_id)

				this.data.pair_plots[plot_id] = { x : x_attr, y : y_attr }
			}
		},

		delete_plot(plot_id)
		{
			const last_plot = this.plots.length == 1
			const ind = this.plots.findIndex(desc => desc.id == plot_id)

			api.call(this, "cadastral_cost_evaluation", "unset_field", { id : this.id, field : `modeling.pair_plots.${plot_id}` }, () => {})

			this.plots.splice(ind, 1)
			delete this.data.pair_plots[plot_id]

			if(last_plot)
				this.refresh()
		},

		export_models()
		{
			api.call(this, "cadastral_cost_evaluation", "export_models", { id : this.id }, api.open_response_url)
		},

		set_x(plot_id, attr_id)
		{
			var plot = this.plots.find(plot => plot.id == plot_id)
			var attr = this.attrs.find(attr => attr.id == attr_id)

			plot.initial_x = attr_id
			this.data.pair_plots[plot_id].x = attr
		},

		set_y(plot_id, attr_id)
		{
			var plot = this.plots.find(plot => plot.id == plot_id)
			var attr = this.attrs.find(attr => attr.id == attr_id)

			plot.initial_y = attr_id
			this.data.pair_plots[plot_id].y = attr
		},
	}
}

</script>

